import { render, staticRenderFns } from "./AdminReopenSiteButton.vue?vue&type=template&id=22512403"
import script from "./AdminReopenSiteButton.vue?vue&type=script&lang=js"
export * from "./AdminReopenSiteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports